var _path, _g, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic_lock",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 42,
    viewBox: "0 0 30 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4021",
    "data-name": "\\uD328\\uC2A4 4021",
    d: "M133.613,23.207a2.826,2.826,0,0,1-2.86-2.791V11.744a6.314,6.314,0,0,0-12.625,0v8.673a2.861,2.861,0,0,1-5.72,0V11.744a12.036,12.036,0,0,1,24.064,0v8.673A2.826,2.826,0,0,1,133.613,23.207Z",
    transform: "translate(-109.44)",
    fill: "#c7cfe2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2379",
    "data-name": "\\uADF8\\uB8F9 2379",
    transform: "translate(2.968 14.253)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4022",
    "data-name": "\\uD328\\uC2A4 4022",
    d: "M115.2,182.623a2.791,2.791,0,0,0,2.791-2.791v-6.217h-5.583v6.217A2.791,2.791,0,0,0,115.2,182.623Z",
    transform: "translate(-112.408 -173.614)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4023",
    "data-name": "\\uD328\\uC2A4 4023",
    d: "M331.333,173.614v6.217a2.791,2.791,0,0,0,5.583,0v-6.217Z",
    transform: "translate(-312.851 -173.614)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4024",
    "data-name": "\\uD328\\uC2A4 4024",
    d: "M103.466,207.745H78.774a2.629,2.629,0,0,0-2.654,2.6v19.678a2.629,2.629,0,0,0,2.654,2.6h24.692a2.629,2.629,0,0,0,2.654-2.6V210.348A2.629,2.629,0,0,0,103.466,207.745Z",
    transform: "translate(-76.12 -190.628)",
    fill: "#ffd782"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4025",
    "data-name": "\\uD328\\uC2A4 4025",
    d: "M223.2,301.113a3.207,3.207,0,1,0-5.186,2.522v6.1h3.959v-6.1A3.2,3.2,0,0,0,223.2,301.113Z",
    transform: "translate(-204.994 -273.416)",
    fill: "#a67744"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLock);
export default __webpack_public_path__ + "static/media/ic_lock.dcf27d26482e076bb85fd9af8dde31ac.svg";
export { ForwardRef as ReactComponent };